import React from "react";
import SignInLayer from "../../components/Auth/SignInLayer";
import "../../custom.css";

const SignInPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <SignInLayer />

    </>
  );
};

export default SignInPage; 
